import { Stack } from '@mantine/core';

import { PaperContent } from '@/module/Author/Paper/components/PaperContent';
import { PublicationContent } from '@/module/Author/Publication/components/PublicationContent';
import { ReviewDeleteButton } from '@/module/Author/Review/components/ReviewDeleteButton';
import { ReviewImpactFactor } from '@/module/Author/Review/components/ReviewImpactFactor';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { ReviewProofAction } from './Proof';
import { Review } from './model/ReviewTypes';

interface ReviewViewProps {
  review: Review;
}

export function ReviewView({ review }: ReviewViewProps) {
  const { authors } = review;

  return (
    <Stack>
      <PublicationContent
        publication={review}
        authorsNo={authors.length}
        editAction={
          <EditButtonLink
            size="xs"
            miw="100px"
          />
        }
        deleteAction={<ReviewDeleteButton reviewId={review.id} />}
      />
      <PaperContent
        paper={review}
        metrics={<ReviewImpactFactor reviewId={review.id} />}
      />
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <ReviewProofAction
        reviewId={review.id}
        authors={authors}
      />
    </Stack>
  );
}
